export const messageErrorFields =
  'Complete todos los campos para realizar la búsqueda';
export const messageErrorPaices = 'El Origen y Destino son iguales';
export const messageErrorDates = 'Las fechas de salida deben estar en orden';
export const messageErrorDollar =
  'Para vuelos dentro del territorio nacional, solo está permitida la emisión en pesos';
